module.exports = __webpack_public_path__ + "img/08.3659bcac.jpg";